import React from 'react';
import styled from '@emotion/styled';
import Skeleton from '@unicons-base/Skeleton/Skeleton';
import { Spacings } from '@styles/index';

const SkeletonCard = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_5B};
`;

const SkeletonContent = styled.div`
  margin-left: ${Spacings.SPACING_3B};
`;

const LessonsListSkeleton: React.FC = () => {
  const cards = 4;

  return (
    <main>
      {[...Array(cards).keys()].map((_, index) => (
        <SkeletonCard key={String(index)}>
          <Skeleton height="80px" width="40%" />
          <SkeletonContent>
            <Skeleton
              height="15px"
              width="180px"
              style={{ marginBottom: '8px' }}
            />
            <Skeleton
              height="10px"
              width="96px"
              style={{ marginBottom: '0' }}
            />
          </SkeletonContent>
        </SkeletonCard>
      ))}
    </main>
  );
};

LessonsListSkeleton.displayName = 'LessonsListSkeleton';

export default LessonsListSkeleton;
